import {
  SettingsBasicInfo,
  // SettingsSubscription,
  // SettingsGroup,
  SettingsNotifications,
  // SettingsPrivacy,
} from '@/components/Settings'
import type { TabType } from './types'

const settingsTabs: TabType[] = [
  {
    url: 'info',
    label: 'Basic Info',
    component: SettingsBasicInfo,
  },
  // {
  //   url: 'subscription',
  //   label: 'Subscription',
  //   component: SettingsSubscription,
  //   disabled: true,
  // },
  // {
  //   url: 'group',
  //   label: 'Group',
  //   component: SettingsGroup,
  //   disabled: true,
  // },
  {
    url: 'notifications',
    label: 'Notifications',
    component: SettingsNotifications,
  },
  // {
  //   url: 'privacy',
  //   label: 'Privacy',
  //   component: SettingsPrivacy,
  // },
]

export default settingsTabs
